import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-card-focus",
  templateUrl: "./card-focus.component.html",
  styleUrls: ["./card-focus.component.scss"]
})
export class CardFocusComponent {
  @Input()
  lang: "en" | "fr" = "en";

  @Input()
  showCardFocus;

  constructor() {}
}
